enum ButtonTheme {
  BrightPurpleOutline = "BrightPurpleOutline",
  BrightPurpleOutlineWebsiteBackground = "BrightPurpleOutlineWebsiteBackground",
  CadmiumGreen = "CadmiumGreen",
  DarkGunmetal = "DarkGunmetal",
  LightPinkOutline = "LightPinkOutline",
  MaximumRed = "MaximumRed",
  MediumBlue = "MediumBlue",
  MidnightBlue = "MidnightBlue",
  Navy = "Navy",
  NavyOutline = "NavyOutline",
  NavyOutlineSquare = "NavyOutlineSquare",
  PurpleGradient = "PurpleGradient",
  PurpleOutline = "PurpleOutline",
  Red = "Red",
  RedOutline = "RedOutline",
  SecondaryOutline = "SecondaryOutline",
  Sinopia = "Sinopia",
  White = "White",
  WhiteOutline = "WhiteOutline",
  WhiteWithPurpleGradient = "WhiteWithPurpleGradient",
}

export default ButtonTheme;
